import PropTypes from 'prop-types';
import React from 'react';

export default function CheckboxColumn({ row, col, cell }) {
  return (
    <label className="checkbox-column">
      <input type="checkbox" onChange={() => col.columnConfig.onClick(row, !cell.value)} checked={cell.value} />
    </label>
  );
}

CheckboxColumn.defaultWidth = 40;

CheckboxColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row:obj, value:bool) :=> {}
    }).isRequired,
  }).isRequired, // column config
  cell: PropTypes.shape({
    value: PropTypes.bool,
  }).isRequired,
};
